// extracted by mini-css-extract-plugin
export default {"whySpotifyProjects":"WhySpotifyProjects_whySpotifyProjects__u6iSZ","whyProjectsSubHeading":"WhySpotifyProjects_whyProjectsSubHeading__p0Sd+"};